<div class="scoreboard">
    <div class="segment-display">
        <div class="digit" *ngFor="let digit of formatNumber(remainingMines)">
        <div class="segment" [class.on]="digitMap[digit][0]"></div>
        <div class="segment" [class.on]="digitMap[digit][1]"></div>
        <div class="segment" [class.on]="digitMap[digit][2]"></div>
        <div class="segment" [class.on]="digitMap[digit][3]"></div>
        <div class="segment" [class.on]="digitMap[digit][4]"></div>
        <div class="segment" [class.on]="digitMap[digit][5]"></div>
        <div class="segment" [class.on]="digitMap[digit][6]"></div>
        </div>
    </div>
    <!-- <button class="game-state" (click)="reset()"></button> -->
    <button class="game-state" (click)="reset()" [ngStyle]="{'background-image': getEmoji()}"></button>
    <div class="segment-display">
        <div class="digit" *ngFor="let digit of formatNumber(totalMines)">
        <div class="segment" [class.on]="digitMap[digit][0]"></div>
        <div class="segment" [class.on]="digitMap[digit][1]"></div>
        <div class="segment" [class.on]="digitMap[digit][2]"></div>
        <div class="segment" [class.on]="digitMap[digit][3]"></div>
        <div class="segment" [class.on]="digitMap[digit][4]"></div>
        <div class="segment" [class.on]="digitMap[digit][5]"></div>
        <div class="segment" [class.on]="digitMap[digit][6]"></div>
        </div>
    </div>
</div>